import { useData } from '@hooks/useData';
import { components } from '@apiSchema';
import http from '@core/fetch';
import apiConfig from '@apiConfig';

export type TerritoryOption = { id: string; label: string };

export interface TerritoryOptions {
    states: TerritoryOption[];
    metros: TerritoryOption[];
}

type TerritoryOptionsResponse = components['schemas']['TerritoryOptionsResponse'];

const REQUEST_TYPE: keyof typeof apiConfig = 'get territory options';
const DEFAULT_DATA: TerritoryOptions = { states: [], metros: [] };

export function mapTerritoryOptions(response: TerritoryOptionsResponse): TerritoryOptions {
    const byLabel = (a: TerritoryOption, b: TerritoryOption) => a.label.localeCompare(b.label);
    return {
        states: (response.states ?? [])
            .map(s => ({ id: s.id ?? '', label: s.displayName ?? '' }))
            .sort(byLabel),
        metros: (response.metros ?? [])
            .map(m => ({ id: String(m.id), label: m.displayName ?? '' }))
            .sort(byLabel),
    };
}

async function getTerritoryOptions(): Promise<TerritoryOptions> {
    const response: TerritoryOptionsResponse = await http.get(REQUEST_TYPE);
    return mapTerritoryOptions(response);
}

export default function useTerritoryOptions() {
    const { isLoading, data } = useData(DEFAULT_DATA, getTerritoryOptions);
    return { states: data.states, metros: data.metros, isLoading };
}
